module.exports = __webpack_public_path__ + "static/media/sensa-white.7f3572cd.svg";